//
import Model from '@/models/Model'

/**
 * @class
 */
export default class AccCostCenter extends Model {
    /**
     *
     */
    resource() {
        return 'acc_purchase_sale_book'
    }

    /**
     *
     */
    toAttach() {
        //
        return this.clean([
            'accounting_date',
            'credit_notes',
            'debit_notes',
            'invoices',
        ])
    }

    get isReviewed() {
        return !!this.reviewed_at
    }

    static includes = ['g_user.hr_employee', 'g_reviewer_user.hr_employee']
}
